import { render, staticRenderFns } from "./shopBalanceParamsList.vue?vue&type=template&id=5509dd7a&scoped=true"
import script from "./shopBalanceParamsList.vue?vue&type=script&lang=js"
export * from "./shopBalanceParamsList.vue?vue&type=script&lang=js"
import style0 from "./shopBalanceParamsList.vue?vue&type=style&index=0&id=5509dd7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5509dd7a",
  null
  
)

export default component.exports